export class TableTextStyle {
  color = '';
  size = 'uk-h5';
  font = 'tb-font-primary';

  static normalize(styles: Partial<TableTextStyle>): TableTextStyle {
    const pureStyles = new TableTextStyle();

    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;

    return pureStyles;
  }
}
